export class TicketModel {

    public id: number;
    public typeId: number;
    public statusId: number;
    public createdAt: string;
    public modifiedAt: string;
    public subject: string;
    public comment: string;
    public message: string;
    public assignedTo: string;
    public assignedToId: string;

    constructor(obj?: any) {
        this.id            = obj && obj.id           || null;
        this.typeId        = obj && obj.typeId       || null;
        this.statusId      = obj && obj.statusId     || null;
        this.createdAt     = obj && obj.createdAt    || '';
        this.modifiedAt    = obj && obj.modifiedAt   || '';
        this.subject       = obj && obj.subject      || '';
        this.comment       = obj && obj.comment      || '';
        this.message       = obj && obj.message      || '';
        this.assignedTo    = obj && obj.assignedTo   || '';
        this.assignedToId  = obj && obj.assignedToId || null;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/ticket.model.ts